import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListePassagesFQCQ = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"ListePassagesFQCQ"}/>
        </div>
    );
}
export default ListePassagesFQCQ;